import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/plat/admin/exportTask/';

function baseApi() {

    function retryUpload(id) {
        return Post(baseUrl + `retryUpload/${id}`, {});
    }

    function queryExportTask(data) {
        return Post(baseUrl + 'queryExportTask', data);
    }

    function updateExportTask(data) {
        return Post(baseUrl + 'updateExportTask', data);
    }

    function queryExportTaskTypeList() {
        return Post(baseUrl + 'queryExportTaskTypeList', {});
    }


    return {
        retryUpload, queryExportTask, queryExportTaskTypeList, updateExportTask
    };
}

export const exportTaskApi = baseApi();
